$(document).ready(function (){

	$('.ce__topicteaser--slider').each(function(){

		new window.Swiper($(this), {
			slidesPerView: 1,
			autoplay: false,
			cssWidthAndHeight: true,
			autoHeight: true,
			spaceBetween: 20,
			a11y: {
				prevSlideMessage: 'Vorheriges Element',
				nextSlideMessage: 'Nächstes Element',
			},
			// loop: true,
			pagination: {
				el: $('.swiper-pagination', this),
				dynamicBullets: true,
				dynamicMainBullets: 3,
				clickable: true
			},
			navigation: {
				nextEl: $('.swiper-news-next', this),
				prevEl: $('.swiper-news-prev', this),
			},
			breakpoints: {
				768: {
					autoHeight: false,
					slidesPerView: 'auto',
					spaceBetween: 0
				}
			}
		});
	})
});
